import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState } from 'react';
import { LINKS } from '@/constants/links';
import { Button } from '@/components/buttons';
import { useTranslation } from 'react-i18next';
import { CalculatorForm } from './CalculatorForm';
import { Modal } from '@/components/modal';
import { formatAmount } from '@/utils/formatting';
import { Language } from '@/constants/currencyConfig';
import { SectionHeadline } from '@/components/SectionHeadline';
import { useCalculator } from './useCalculator';
import { formatApiAmount } from '@/utils/amount';
import { CalculatorResultRow } from '@/components/CalculatorResultRow';
const PRINCIPAL_MAX = 100_000;
const PRINCIPAL_MIN = 1_500;
const DEFAULT_SELECTED_PRINCIPAL = 50_000;
export type CalculatorType = 'installments' | 'loan';
interface CalculatorProps {
  type?: CalculatorType;
}
export function Calculator(props) {
  const $ = _c(103);
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [maxPrincipal, setMaxPrincipal] = useState(DEFAULT_SELECTED_PRINCIPAL);
  const t0 = props.type === "loan" ? "loan" : "installments";
  let t1;
  if ($[0] !== t0) {
    t1 = [t0];
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    t,
    i18n
  } = useTranslation(t1);
  const [paymentsCount, setPaymentsCount] = useState(10);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = t3 => {
      const {
        maxPrincipal: selectedPrincipal,
        paymentsCount: selectedPaymentsCount
      } = t3;
      setMaxPrincipal(selectedPrincipal);
      setPaymentsCount(selectedPaymentsCount);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const calculate = t2;
  const calculator = useCalculator(maxPrincipal * 100, paymentsCount);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsModalOpened(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("calculator.example.title");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <h2 className="mb-6 text-xl font-semibold">{t4}</h2>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("calculator.example.text.1");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <p className="mb-4 text-sm sm:text-base">{t6}</p>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("calculator.example.subtitle");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <h3 className="mb-1 text-sm font-semibold sm:text-base">{t8}</h3>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("calculator.example.text.2");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <p className="mb-4 text-sm sm:text-base">{t10}</p>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== isModalOpened || $[21] !== t11 || $[22] !== t5 || $[23] !== t7 || $[24] !== t9) {
    t12 = <Modal isVisible={isModalOpened} onClose={t3} modalName="postponeDueDateCalculatorExample" analyticsParam="postponeDueDateCalculatorExample" testId="postponeDueDateCalculatorExample" className="max-w-[48rem] rounded-4xl p-10">{t5}{t7}{t9}{t11}</Modal>;
    $[20] = isModalOpened;
    $[21] = t11;
    $[22] = t5;
    $[23] = t7;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const t13 = `${props.type === "loan" ? "loan" : "installments"}.calculator.title`;
  let t14;
  if ($[26] !== t) {
    t14 = t("calculator.title");
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13 || $[29] !== t14) {
    t15 = <SectionHeadline className="mb-10 px-4 md:mb-16" variant="inverted" anchorKey={t13}>{t14}</SectionHeadline>;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== calculator.installments || $[32] !== calculator.isLoading || $[33] !== props.type) {
    t16 = <CalculatorForm type={props.type} principalMax={PRINCIPAL_MAX} principalMin={PRINCIPAL_MIN} onChange={calculate} installments={calculator.installments} isLoading={calculator.isLoading} />;
    $[31] = calculator.installments;
    $[32] = calculator.isLoading;
    $[33] = props.type;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t) {
    t17 = t("calculator.table.monthly");
    $[35] = t;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== calculator.selectedPlan?.installmentValue?.amount || $[38] !== i18n.language) {
    t18 = formatAmount(formatApiAmount(calculator?.selectedPlan?.installmentValue?.amount || 0), i18n.language as Language);
    $[37] = calculator.selectedPlan?.installmentValue?.amount;
    $[38] = i18n.language;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t17 || $[41] !== t18) {
    t19 = <CalculatorResultRow highlighted={true} title={t17} value={t18} />;
    $[40] = t17;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t) {
    t20 = t("calculator.table.plusYouPay");
    $[43] = t;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== calculator.selectedPlan?.totalInterestValue?.amount || $[46] !== i18n.language) {
    t21 = formatAmount(formatApiAmount(calculator?.selectedPlan?.totalInterestValue?.amount || 0), i18n.language as Language);
    $[45] = calculator.selectedPlan?.totalInterestValue?.amount;
    $[46] = i18n.language;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t20 || $[49] !== t21) {
    t22 = <CalculatorResultRow highlighted={true} title={t20} value={t21} />;
    $[48] = t20;
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t) {
    t23 = t("calculator.table.inTotal");
    $[51] = t;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== calculator.selectedPlan?.totalClaim?.amount || $[54] !== i18n.language) {
    t24 = formatAmount(formatApiAmount(calculator?.selectedPlan?.totalClaim?.amount || 0), i18n.language as Language);
    $[53] = calculator.selectedPlan?.totalClaim?.amount;
    $[54] = i18n.language;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t23 || $[57] !== t24) {
    t25 = <CalculatorResultRow highlighted={true} title={t23} value={t24} />;
    $[56] = t23;
    $[57] = t24;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t) {
    t26 = t("calculator.table.annualInterestRate");
    $[59] = t;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  const t27 = `${calculator.selectedPlan?.interestRate || 0} %`;
  let t28;
  if ($[61] !== t26 || $[62] !== t27) {
    t28 = <CalculatorResultRow title={t26} value={t27} />;
    $[61] = t26;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== t) {
    t29 = t("calculator.table.rpsn");
    $[64] = t;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  const t30 = `${calculator.selectedPlan?.rpsn || 0} %`;
  let t31;
  if ($[66] !== t29 || $[67] !== t30) {
    t31 = <CalculatorResultRow title={t29} value={t30} />;
    $[66] = t29;
    $[67] = t30;
    $[68] = t31;
  } else {
    t31 = $[68];
  }
  let t32;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = LINKS();
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  const t33 = t32.registration;
  let t34;
  if ($[70] !== t) {
    t34 = t("calculator.cta");
    $[70] = t;
    $[71] = t34;
  } else {
    t34 = $[71];
  }
  let t35;
  if ($[72] !== t34) {
    t35 = <Button to={t33} testId="postponeDueDateRegistration" analyticsParam="postponeDueDateRegistration" size="lg" variant="primary" align="center" className="mt-6 mb-3 max-w-full md:hidden lg:mt-0">{t34}</Button>;
    $[72] = t34;
    $[73] = t35;
  } else {
    t35 = $[73];
  }
  let t36;
  if ($[74] !== t19 || $[75] !== t22 || $[76] !== t25 || $[77] !== t28 || $[78] !== t31 || $[79] !== t35) {
    t36 = <div className="mt-12 mb-4 flex flex-col items-center justify-between gap-3 rounded-2xl bg-blue-500 p-6 text-white md:mb-12">{t19}{t22}{t25}{t28}{t31}{t35}</div>;
    $[74] = t19;
    $[75] = t22;
    $[76] = t25;
    $[77] = t28;
    $[78] = t31;
    $[79] = t35;
    $[80] = t36;
  } else {
    t36 = $[80];
  }
  let t37;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = LINKS();
    $[81] = t37;
  } else {
    t37 = $[81];
  }
  const t38 = t37.registration;
  let t39;
  if ($[82] !== t) {
    t39 = t("calculator.cta");
    $[82] = t;
    $[83] = t39;
  } else {
    t39 = $[83];
  }
  let t40;
  if ($[84] !== t39) {
    t40 = <Button to={t38} testId="postponeDueDateRegistration" analyticsParam="postponeDueDateRegistration" size="lg" variant="primary" align="center" className="mb-3 hidden md:block">{t39}</Button>;
    $[84] = t39;
    $[85] = t40;
  } else {
    t40 = $[85];
  }
  let t41;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = () => setIsModalOpened(true);
    $[86] = t41;
  } else {
    t41 = $[86];
  }
  let t42;
  if ($[87] !== t) {
    t42 = t("calculator.example.cta");
    $[87] = t;
    $[88] = t42;
  } else {
    t42 = $[88];
  }
  let t43;
  if ($[89] !== t42) {
    t43 = <div className="text-center"><Button variant="unstyled" onClick={t41} testId="postponeDueDateCalculatorExample" analyticsParam="postponeDueDateCalculatorExample" align="center" className="text-blue-500 underline">{t42}</Button></div>;
    $[89] = t42;
    $[90] = t43;
  } else {
    t43 = $[90];
  }
  let t44;
  if ($[91] !== t16 || $[92] !== t36 || $[93] !== t40 || $[94] !== t43) {
    t44 = <div className="mx-auto max-w-[60.5rem] rounded-2xl bg-blue-100 p-4 text-gray-900 md:rounded-[2.5rem] md:p-12 md:pt-14">{t16}{t36}{t40}{t43}</div>;
    $[91] = t16;
    $[92] = t36;
    $[93] = t40;
    $[94] = t43;
    $[95] = t44;
  } else {
    t44 = $[95];
  }
  let t45;
  if ($[96] !== t15 || $[97] !== t44) {
    t45 = <div className="relative z-10 px-2">{t15}{t44}</div>;
    $[96] = t15;
    $[97] = t44;
    $[98] = t45;
  } else {
    t45 = $[98];
  }
  let t46;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <div className="bgCircle absolute top-[10%] left-2/3" />;
    $[99] = t46;
  } else {
    t46 = $[99];
  }
  let t47;
  if ($[100] !== t12 || $[101] !== t45) {
    t47 = <>{t12}{t45}{t46}</>;
    $[100] = t12;
    $[101] = t45;
    $[102] = t47;
  } else {
    t47 = $[102];
  }
  return t47;
}